/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_age_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. Set the 'age at' date to any day in the past or future, and the calculator recalculates your exact age (or the age you'll be) as of that date — useful for checking eligibility on a specific deadline or working out how old you'll be for a future event.`)
};

const es_age_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí. Establece la fecha de 'edad en' a cualquier día en el pasado o futuro, y la calculadora recalcula tu edad exacta (o la edad que tendrás) a partir de esa fecha — útil para verificar elegibilidad en una fecha límite específica o para averiguar cuántos años tendrás para un evento futuro.`)
};

const de_age_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Setzen Sie das Datum "Alter am" auf einen beliebigen Tag in der Vergangenheit oder Zukunft, und der Rechner berechnet Ihr genaues Alter (oder das Alter, das Sie sein werden) an diesem Datum neu — nützlich zur Überprüfung der Berechtigung an einem bestimmten Stichtag oder um zu berechnen, wie alt Sie bei einem zukünftigen Ereignis sein werden.`)
};

const nl_age_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Stel de 'leeftijd op' datum in op een willekeurige dag in het verleden of de toekomst, en de calculator berekent uw exacte leeftijd (of de leeftijd die u zult hebben) op die datum opnieuw — handig voor het controleren van geschiktheid op een specifieke deadline of voor het bepalen hoe oud u bent op een toekomstig evenement.`)
};

const fr_age_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui. Définissez la date « âge à » sur n'importe quel jour du passé ou du futur, et la calculatrice recalcule votre âge exact (ou l'âge que vous aurez) à cette date — utile pour vérifier l'admissibilité à une date limite spécifique ou déterminer quel âge vous aurez pour un événement futur.`)
};

const it_age_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì. Imposta la data 'età alla data' su qualsiasi giorno nel passato o nel futuro, e il calcolatore ricalcola la tua età esatta (o l'età che avrai) a quella data — utile per verificare l'idoneità in una scadenza specifica o per scoprire quanti anni avrai per un evento futuro.`)
};

const pt_br2_age_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Defina a data de 'idade em' para qualquer dia no passado ou futuro e a calculadora recalcula sua idade exata (ou a idade que você terá) naquela data — útil para verificar elegibilidade em um prazo específico ou descobrir quantos anos você terá para um evento futuro.`)
};

const pt_age_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Defina a data de "idade em" para qualquer dia no passado ou futuro, e a calculadora recalcula a sua idade exata (ou a idade que terá) nessa data — útil para verificar a elegibilidade numa data limite específica ou para descobrir com que idade estará para um evento futuro.`)
};

const ja_age_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。「特定の日付での年齢」を過去または将来のいずれかの日に設定し、計算機は特定の日付の時点でのあなたの正確な年齢（またはあなたがいくつになるか）を再計算します - 特定の期限での適格性をチェックしたり、将来のイベントのあなたの年齢を計算したりするのに便利です。`)
};

const zh_age_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以。将“计算日期”设置为过去或未来的任意一天，计算器就会重新计算出截至该日期的精确年龄（或届时的年龄）——这在核查特定截止日期的资格，或计算某个未来事件时您的年龄时非常实用。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const age_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.age_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("age_faq2_a", locale)
	if (locale === "en") return en_age_faq2_a(inputs)
	if (locale === "es") return es_age_faq2_a(inputs)
	if (locale === "de") return de_age_faq2_a(inputs)
	if (locale === "nl") return nl_age_faq2_a(inputs)
	if (locale === "fr") return fr_age_faq2_a(inputs)
	if (locale === "it") return it_age_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_age_faq2_a(inputs)
	if (locale === "pt") return pt_age_faq2_a(inputs)
	if (locale === "ja") return ja_age_faq2_a(inputs)
	return zh_age_faq2_a(inputs)
};